/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { ImageUrls } from '@client/types'
import { validateEmail } from '@client/utils/validateEmail'
import { makeClassName } from '@utils/makeClassName'

import { BeetBlockIcon } from './BeetBlockIcon'
import { locale } from './locale'

import styles from './BeetBlock.module.css'

interface BriefSubscriptionProps {
  correlation?: keyof ImageUrls
  handleSubscribe: any
  daily: any
  email: any
  handleInput: any
  error: any
  isLoading: boolean
}

export const BeetBlock: React.FC<BriefSubscriptionProps> = ({
  correlation,
  handleSubscribe,
  daily,
  email,
  handleInput,
  error,
  isLoading
}) => {
  const {
    action,
    label,
    head_title,
    title,
    success_message,
    something_wrong
  } = locale

  return (
    <div
      className={makeClassName([
        [[styles.root], true],
        [
          !!correlation && styles[correlation],
          !!correlation && !!styles[correlation]
        ]
      ])}
    >
      <div className={styles.body}>
        <div className={styles.content}>
          <div className={styles.headTitle}>
            <p dangerouslySetInnerHTML={{ __html: head_title }} />
          </div>
          <div className={styles.icon}>
            <BeetBlockIcon />
          </div>
          <h3
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />

          <form className={styles.subscribe} onSubmit={handleSubscribe}>
            {!daily.subscribed && (
              <div
                className={makeClassName([
                  [[styles.form], true],
                  [[styles.notVisible], daily.subscribed]
                ])}
              >
                <div
                  className={makeClassName([
                    [[styles.field], true],
                    [[styles.invalid], error || daily.error]
                  ])}
                >
                  <label htmlFor="brief-email">
                    <span>{label}</span>
                  </label>
                  <input
                    className={styles.input}
                    type="email"
                    defaultValue={email}
                    onInput={handleInput}
                    id="brief-email"
                    placeholder={label}
                  />
                </div>

                <button
                  className={styles.button}
                  disabled={!validateEmail(email) || isLoading}
                  type="submit"
                  aria-label={action}
                >
                  Subscribe
                </button>
              </div>
            )}

            {daily.subscribed && (
              <div
                className={styles.success}
                dangerouslySetInnerHTML={{ __html: success_message }}
              />
            )}

            <div className={styles.description}>
              <p
                className={styles.captcha}
                dangerouslySetInnerHTML={{ __html: locale.captcha }}
              />
              {error ||
                (daily.error && (
                  <span
                    className={styles.message}
                    dangerouslySetInnerHTML={{
                      __html: something_wrong
                    }}
                  />
                ))}
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
